export const config = {
    apiKey: "AIzaSyDz1ZRCHi8xy7x6o6CPJ14atWR4gogFUB0",
    authDomain: "scgc-transcycle-website.firebaseapp.com",
    databaseURL: "https://scgc-transcycle-website.firebaseio.com",
    projectId: "scgc-transcycle-website",
    storageBucket: "scgc-transcycle-website.appspot.com",
    messagingSenderId: "602984451732",
    appId: "1:602984451732:web:ca346c077f85b36b88ee81",
    measurementId: "G-F56BSBF6CL"
}